import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteInspectionAqlService extends IApiBackendRouteService {
  protected urlRoute = `${API_BASE_URL}/inspection/aql`;
  constructor(protected readonly http: HttpClient) {
    super();
  }

  all(): Observable<{ id: number; name: string }[]> {
    return this.http.get<{ id: number; name: string }[]>(`${this.urlRoute}`);
  }
}
